import { render } from "./ListOrganes.vue?vue&type=template&id=96a1d1ee&ts=true"
import script from "./ListOrganes.vue?vue&type=script&lang=ts"
export * from "./ListOrganes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__